/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-direction:column;align-items:center;max-width:350px}caroo-lottie[_ngcontent-%COMP%]{margin:-40px 0 -16px}h1[_ngcontent-%COMP%], p[_ngcontent-%COMP%]{text-align:center}h1[_ngcontent-%COMP%]{margin:0 0 16px}p[_ngcontent-%COMP%]{margin-bottom:16px}div.actions[_ngcontent-%COMP%]{display:grid;grid-auto-flow:column;grid-column-gap:16px}button[_ngcontent-%COMP%]{width:-webkit-max-content;width:-moz-max-content;width:max-content}"];
export { styles as styles };
